module.exports = __webpack_public_path__ + "static/img/RAPZ1_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPZ1_1.png
// module id = S4N1
// module chunks = 0